import React from "react";
import "./pageheader.scss";

// Shared page heading used across pages so the title/subtitle size and alignment are uniform
// in one place (24px/700 title, 15px muted subtitle, left-aligned). Props (all optional but
// `title`):
//   title     main heading text/node
//   subtitle  muted tagline under the title
//   eyebrow   small uppercase kicker above the title (e.g. "AWS onboarding")
//   badge     small pill shown beside the title (e.g. "Dashboard")
//   actions   right-aligned node on the same row (e.g. search input + button)
//   className extra class on the wrapper
export default function PageHeader({ title, subtitle, eyebrow, badge, actions, className = "" }) {
  return (
    <div className={`page-header ${className}`.trim()}>
      <div className="page-header-main">
        {eyebrow && <span className="page-header-eyebrow">{eyebrow}</span>}
        <h1 className="page-header-title">
          {title}
          {badge && <span className="page-header-badge">{badge}</span>}
        </h1>
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
}
